import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  formatButton: {
    width: 96,
    '&:not(:first-child)': {
      marginLeft: theme.spacing(2),
    },
  },
  check: {
    marginRight: theme.spacing(1),
  },
}))
